import React, { Fragment } from 'react';
import { Backdrop } from './Backdrop';
import { Card } from 'components/Card/Card'
import PropTypes from 'prop-types';
import './modal.scss';

const Modal = ({ closeModal, error = null, title = null, description = null, children, backdropClass = null }) => {
    return (
        <Fragment>
            <Backdrop closeModal={closeModal} backdropClass={backdropClass} >
                <Card className={`modal-window ${error ? "modal-error-border" : ""}`}>
                    {title && <h2 className="modal-title">{title}</h2>}
                    {description && <div className="modal-description">{description}</div>}
                    {children}
                </Card>
            </Backdrop>
        </Fragment>
    );
};

Modal.propTypes = {
    closeModal: PropTypes.func,
    error: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
};

export { Modal };